module.exports = __webpack_public_path__ + "static/media/teamitem6.620b2491.png";